import React from 'react';

import * as S from './SignUpBanner.styles';

import GiftTagIcon from '../../../../../stories/Icons/GiftTagIcon';

const SignUpBanner = ({actionHandler}) => {
  return (
    <S.SignUpBannerContainer onClick={actionHandler}>
      <S.SignUpBannerLeftWrap>
        <GiftTagIcon />
        <S.SignUpTextWrap>Login & unlock special deals, discounts & more!</S.SignUpTextWrap>
      </S.SignUpBannerLeftWrap>
      <S.SignUpButtonWrap>LOGIN NOW</S.SignUpButtonWrap>
    </S.SignUpBannerContainer>
  );
};

export default SignUpBanner;
